import { useNuxtApp } from 'nuxt/app';
import type { Schema } from '~~/common/types/api';

type AddressType = Schema<'AddressModel'>;

interface StockTypeInterface {
  store: {
    address: AddressType;
    stock: number;
    defaultDeliveryMode: (shipmentMethod: string) => string;
    token: string;
    isDisabled: (predictedStock?: number) => boolean;
    icon: {
      name: string;
      size: number;
      fill: boolean;
    };
  };
  logistic: {
    stock: number;
    defaultDeliveryMode: (shipmentMethod: string) => string;
    token: string;
    isDisabled: (predictedStock: number) => boolean;
    icon: {
      name: string;
      size: number;
      fill: boolean;
    };
  };
}

interface ExtendedStockTypeInterface extends StockTypeInterface {
  addressText: string;
  mapsUrl: string,
}

export function getAddress (data: AddressType): string {
  return [data.city ? `${data.city},` : null, data.streetName, data.streetType, data.streetNo].filter(element => Boolean(element)).join(' ');
}

export function getUrlFormattedAddress (data: AddressType): string {
  return [data.postCode, data.city, data.streetName, data.streetType, data.streetNo].filter(element => Boolean(element)).join('+');
}

export function getMapsUrl (data: AddressType): string {
  const nuxt = useNuxtApp();
  return nuxt.$awMergedConfig.googleMapsAddressBaseUrl + getUrlFormattedAddress(data);
}

export function createStockInfosList (stockInfos: StockTypeInterface[]): ExtendedStockTypeInterface[] {
  return stockInfos.map((stockInfo: StockTypeInterface) => {
    return {
      ...stockInfo,
      addressText: getAddress(stockInfo.store.address),
      mapsUrl: getMapsUrl(stockInfo.store.address),
    };
  });
}
